export const en = {
  paymentsTestBanner: { message: "Test mode: payments in this preview are not real.", learnMore: "Learn more" },
  nav: { features: "Features", modules: "Modules", demo: "Demo", security: "Security", pricing: "Pricing", faq: "FAQ", login: "Sign in", signup: "Start free", menu: "Menu", beta: "Open beta", contactSales: "Contact sales" },
  whatsappFab: { label: "Contact sales", aria: "Contact sales on WhatsApp" },
  heroDemo: {
    studio: "Studio",
    sections: {
      dashboard: "Dashboard",
      research: "AI Research",
      analysis: "Analysis",
      drafting: "Drafting",
      matters: "Matters",
      calendar: "Calendar",
    },
    hint: "Interactive demo. Click an item to explore.",
    overview: "Overview",
    greeting: "Good morning, counselor.",
    allGood: "All on track",
    verified: "Verified",
    question: "Question",
    response: "Response",
    recentActivity: "Recent activity",
    stats: {
      openMatters: "Open matters",
      deadlines7d: "Deadlines 7d",
      researchToday: "Searches today",
      draftsReady: "Drafts ready",
    },
    activities: {
      draftReady: "Demand letter draft ready - Rossi matter",
      research: "Research: tort statute of limitations",
      analysis: "Supply contract review - 3 alerts",
      reminder: "Hearing reminder - Bianchi",
      ago2m: "2 min ago",
      ago8m: "8 min ago",
      ago23m: "23 min ago",
      ago1h: "1h ago",
    },
    queries: {
      research: "What are the limitation periods for tort liability?",
      analysis: "Review this contract and flag any unfair clauses.",
      drafting: "Draft a demand letter for breach of contract.",
      matters: "Show matters with deadlines in the next 7 days.",
      calendar: "What hearings do I have this week?",
    },
    answers: {
      research: "Under art. 2947 of the Italian Civil Code, the ordinary limitation period is 5 years from the event. For tort-as-crime, the criminal-law term applies if longer.",
      analysis: "3 unfair clauses detected under art. 1341 c.c.: exclusive forum (cl. 12), liability cap (cl. 8), unilateral termination (cl. 15). They require a separate signature.",
      drafting: "Draft ready. The notice cites art. 1454 c.c., grants 15 days to perform and references the contract dated 03/12/2024.",
      matters: "4 matters approaching deadline: Rossi v. Bank (brief, 7d), Bianchi (writ, 5d), Verdi (reply, 3d), Neri (appearance, 2d).",
      calendar: "3 hearings: Tue 09:30 Milan Court (Rossi), Thu 11:00 Rome Court (Bianchi), Fri 14:30 Turin Court of Appeal (Verdi).",
    },
    meta: {
      researchKicker: "Legal research",
      researchTitle: "Tort liability — limitation period",
      analysisKicker: "Document review",
      analysisTitle: "Supply contract — unfair clauses",
      draftingKicker: "Assisted drafting",
      draftingTitle: "Demand to perform",
      mattersKicker: "Matters",
      mattersTitle: "Upcoming deadlines",
      calendarKicker: "Schedule",
      calendarTitle: "Hearings this week",
    },
    chips: {
      research: [
        { t: "Cass. 12345/2024", s: "3rd Section" },
        { t: "Cass. 8821/2023", s: "Joint Sections" },
        { t: "Art. 2947 c.c.", s: "Civil Code" },
      ],
      analysis: [
        { t: "Cl. 8 - Liability cap", s: "Unfair" },
        { t: "Cl. 12 - Exclusive forum", s: "Unfair" },
        { t: "Cl. 15 - Termination", s: "Unfair" },
      ],
      drafting: [
        { t: "Art. 1454 c.c.", s: "Demand" },
        { t: "Art. 1218 c.c.", s: "Breach" },
        { t: "Firm template", s: "Reused" },
      ],
      matters: [
        { t: "Rossi v. Bank", s: "7 days" },
        { t: "Bianchi", s: "5 days" },
        { t: "Verdi", s: "3 days" },
      ],
      calendar: [
        { t: "Tue 09:30", s: "Milan Court" },
        { t: "Thu 11:00", s: "Rome Court" },
        { t: "Fri 14:30", s: "Turin CoA" },
      ],
    },
    metrics: {
      research: [
        { k: "Sources", v: "12" },
        { k: "Time", v: "1.4s" },
        { k: "Reliab.", v: "98%" },
      ],
      analysis: [
        { k: "Pages", v: "24" },
        { k: "Alerts", v: "3" },
        { k: "Confidence", v: "94%" },
      ],
      drafting: [
        { k: "Words", v: "412" },
        { k: "References", v: "5" },
        { k: "Time", v: "2.1s" },
      ],
      matters: [
        { k: "Open", v: "27" },
        { k: "Due soon", v: "4" },
        { k: "Closed (mo.)", v: "11" },
      ],
      calendar: [
        { k: "Hearings", v: "3" },
        { k: "Deadlines", v: "4" },
        { k: "Reminders", v: "8" },
      ],
    },
  },
  hero: {
    badge: "Artificial intelligence for law",
    titleA: "The legal AI that always",
    titleB: "cites its sources.",
    subtitle: "Every answer is anchored to statutes, case law and your own documents. AI assists and cites — it does not replace the professional's judgement.",
    ctaPrimary: "Try LexAIPro",
    ctaSecondary: "Request a demo",
    kicker: "Issue No. 01 — Legal Intelligence",
    quote: "An indispensable tool for the firm that faces the future with rigour and vision.",
    quoteAttr: "The LexAIPro desk",
    badges: { gdpr: "GDPR", crypto: "AES-256 encryption", aiAct: "EU AI Act", euData: "Data in EU" },
    stats: { sources: "Searchable sources", time: "Time saved", pros: "Professionals", draft: "To generate a draft" },
  },
  heroTrace: {
    question: "Client's withdrawal in a private works contract: limits and indemnity to the contractor?",
    questionLabel: "Question",
    responseLabel: "Traced answer",
    verified: "Every step is linked to its source",
    sourcesLabel: "Cited sources",
    hint: "Hover or Tab to a phrase to reveal its sources",
    segments: {
      s1: "The client may withdraw from the contract at any time",
      s2: "while indemnifying the contractor for expenses incurred, work done and lost profit",
      s3: "Case law requires that the withdrawal be communicated in a proper, non-abusive manner",
      s4: "In your contract, clause 9 expressly governs the withdrawal procedure",
    },
    sources: {
      a1: { ref: "art. 1671 Civil Code", kind: "Civil Code", note: "Client's unilateral withdrawal" },
      a2: { ref: "Cass. civ. 2855/2021", kind: "Case law", note: "Indemnity and lost profit" },
      a3: { ref: "Contract · clause 9", kind: "Uploaded document", note: "Agreed withdrawal terms" },
    },
  },
  tracciabilita: {
    eyebrow: "Traceability",
    title: "Every answer rests on a source you can consult",
    subtitle: "LexAIPro doesn't make empty claims: it links every step to the statute, judgment or document it comes from. You verify, decide and sign.",
    sources: {
      law: {
        title: "Codes and statutes",
        desc: "Code articles, laws and decrees cited with precise references (e.g. art. 1671 Civil Code) and a link to the text in force.",
        tag: "Legislation",
      },
      caselaw: {
        title: "Case law",
        desc: "Rulings from the Supreme Court, Constitutional Court and lower courts with full citations and the linked holding.",
        tag: "Judgments",
      },
      docs: {
        title: "Your documents",
        desc: "Clauses and passages from the files you upload, cited with page and section for an immediate check.",
        tag: "Documents",
      },
    },
    steps: {
      cite: { title: "Cite", desc: "Every relevant phrase is anchored to the source that justifies it." },
      link: { title: "Link", desc: "Open the reference and read the original text without leaving the context." },
      verify: { title: "Verify", desc: "You confirm relevance and keep control of professional judgement." },
    },
    note: "The AI assists and cites sources, it does not replace the professional's judgement. For fast-moving areas we flag the need to check the latest updates.",
    cta: "See how traceability works",
  },
  audience: {
    eyebrow: "Who it's for",
    title: "Built for those who practice law, every day",
    subtitle: "Same rigour, three ways of working. LexAIPro adapts to your professional context.",
    segments: {
      lawyer: {
        name: "Lawyers",
        tagline: "Solo practitioners",
        desc: "Research, analysis and drafting in a single flow. More time for strategy, less for repetitive work.",
        points: [
          "Legal research with cited, verifiable sources",
          "Drafts of pleadings and opinions in minutes",
          "Document analysis with clause and risk extraction",
        ],
      },
      firm: {
        name: "Law firms",
        tagline: "Teams and associates",
        desc: "Shared knowledge and uniform quality standards across partners, associates and trainees.",
        points: [
          "Shared workspaces per matter",
          "Templates and prompts reusable by the team",
          "Consistency of citations and drafting style",
        ],
      },
      corporate: {
        name: "In-house legal",
        tagline: "Corporate legal teams",
        desc: "Speed on contract volumes, with control, confidentiality and traceability for every decision.",
        points: [
          "Analysis and comparison of contracts at scale",
          "Confidentiality and data stored in the EU",
          "Audit trail on research and generated documents",
        ],
      },
    },
    cta: "Start the free trial",
    ctaSecondary: "Talk to us",
  },
  contact: {
    eyebrow: "Contact",
    title: "Let's talk about your practice",
    subtitle: "Tell us how you work: we'll show you LexAIPro on your real cases. Reply within one business day.",
    form: {
      name: "Full name",
      namePlaceholder: "Jane Doe",
      email: "Email",
      emailPlaceholder: "name@firm.com",
      organization: "Firm or company",
      organizationPlaceholder: "Doe Law Firm",
      segment: "You are…",
      segments: {
        avvocato: "Lawyer",
        studio: "Law firm",
        azienda: "In-house legal",
        altro: "Other",
      },
      message: "Message",
      messagePlaceholder: "Briefly describe your needs…",
      submit: "Send request",
      submitting: "Sending…",
      whatsapp: "Message us on WhatsApp",
      success: "Request sent. We'll get back to you shortly.",
      error: "Sending failed. Try again or message us on WhatsApp.",
      privacy: "By submitting you accept data processing per the Privacy Policy. Data stays in the EU.",
    },
  },
  features: {
    eyebrow: "Three pillars",
    title: "Everything you need to practice better",
    subtitle: "LexAIPro doesn't replace the lawyer. It amplifies your judgement by eliminating repetitive work.",
    items: {
      research: { title: "Legal AI Search", desc: "Ask natural-language questions on Italian and European legislation, case law and doctrine. Structured answers with verifiable sources and precise citations." },
      analysis: { title: "Document Analysis", desc: "Upload any legal document. Get summaries, clause extraction, risk analysis and version comparison in seconds. Multi-language supported." },
      drafting: { title: "Assisted Drafting", desc: "Generate drafts of pleadings, contracts and opinions with natural-language instructions. Iterate to perfection. Over 40 professional templates included." },
    },
  },
  areas: {
    eyebrow: "Practice areas covered",
    title: "Specialist in every field",
    hint: "Scroll to explore all areas →",
    active: "Active",
    scrollLeft: "Scroll left",
    scrollRight: "Scroll right",
    items: {
      civil: { name: "Civil", desc: "Contracts, liability, obligations" },
      commercial: { name: "Commercial", desc: "Corporate, M&A, governance" },
      labor: { name: "Labor", desc: "Contracts, dismissals, unions" },
      tax: { name: "Tax", desc: "Litigation, assessments, VAT" },
      privacy: { name: "Privacy & GDPR", desc: "DPIA, registers, compliance" },
      banking: { name: "Banking", desc: "Loans, anatocism, NPL" },
      criminal: { name: "Criminal", desc: "General crimes, white collar, 231" },
      ip: { name: "Intellectual Property", desc: "Trademarks, patents, copyright" },
      admin: { name: "Administrative", desc: "Tenders, urban planning, appeals" },
      bankruptcy: { name: "Insolvency", desc: "Business crisis, restructuring" },
    },
  },
  demo: {
    eyebrow: "Try it in action",
    title: "See LexAIPro at work",
    subtitle: "Interactive demo: click, type, explore.",
    tabs: { research: "Research", analysis: "Analysis", drafting: "Drafting" },
    today: "Today",
    freeQuestions: "Free questions",
    question: "Question",
    searching: "Searching…",
    retry: "Retry",
    exhaustedTitle: "You've used your 2 free questions",
    exhaustedDesc: "Sign up to keep going with unlimited answers, verified citations and document review.",
    startFree: "Start free",
    seePlans: "See plans",
    inputPlaceholder: "Ask a legal question…",
    sending: "Sending…",
    ask: "Ask",
    errors: {
      exhausted: "You've used your 2 free questions.",
      service: "Service error. Please try again.",
      generic: "Error. Please try again.",
      offline: "No connection. Please try again.",
    },
    presets: {
      prescrizione: {
        label: "Limitation periods",
        question: "What are the limitation periods for tort liability?",
        area: "Civil",
        answer: "Under <span class=\"font-mono text-xs bg-primary/10 px-1 rounded\">art. 2947(1) of the Italian Civil Code</span>, claims for damages from a tortious act are time-barred after <strong>five years</strong> from the day the event occurred. For damages arising from vehicle traffic, the period is reduced to <strong>two years</strong>.",
        sources: [
          { icon: "📜", title: "art. 2947 c.c.", desc: "Right to damages…" },
          { icon: "⚖️", title: "Cass. 3rd Sec., no. 7123/2024", desc: "Dies a quo" },
        ],
      },
      risarcimento: {
        label: "Damages",
        question: "How are non-pecuniary damages quantified?",
        area: "Civil",
        answer: "Non-pecuniary damages (<span class=\"font-mono text-xs bg-primary/10 px-1 rounded\">art. 2059 c.c.</span>) are compensated on an <strong>equitable</strong> basis: the <strong>2024 Milan Tables</strong> are applied for biological and moral damages, with personalisation up to 30% in the presence of peculiar circumstances.",
        sources: [
          { icon: "📜", title: "art. 2059 c.c.", desc: "Non-pecuniary damages" },
          { icon: "📊", title: "Milan Tables 2024", desc: "Biological damage liquidation" },
          { icon: "⚖️", title: "Cass. Joint Sec. 26972/2008", desc: "Twin rulings" },
        ],
      },
      recesso: {
        label: "Contract withdrawal",
        question: "When is unilateral withdrawal from a contract allowed?",
        area: "Civil",
        answer: "Withdrawal is allowed only when agreed by the parties (<span class=\"font-mono text-xs bg-primary/10 px-1 rounded\">art. 1373 c.c.</span>) or by law. In continuing contracts, withdrawal has no retroactive effect. Consumer contracts add a <strong>14-day cooling-off period</strong>.",
        sources: [
          { icon: "📜", title: "art. 1373 c.c.", desc: "Unilateral withdrawal" },
          { icon: "🛡️", title: "Legislative Decree 206/2005", desc: "Consumer Code art. 52" },
        ],
      },
    },
    customArea: "General",
    analysis: {
      docMeta: "Commercial Lease Agreement.pdf · page 3 of 8 - click a clause",
      riskScore: "Risk Score",
      risk: { low: "LOW", med: "MEDIUM", high: "HIGH" },
      clauses: [
        { id: "c1", level: "ok", text: "The annual rent is twenty-four thousand euros", suffix: ", payable in twelve advance monthly instalments.", title: "Compliant", note: "Rent and payment terms are in order." },
        { id: "c2", level: "warn", text: "The tenant agrees to perform at its own cost all extraordinary maintenance work", suffix: " on the property.", title: "Caution", note: "Departs from art. 1576 c.c. - usually borne by the landlord. Verify contractual balance." },
        { id: "c3", level: "risk", text: "In case of late payment, the landlord may terminate the contract without notice", suffix: ", retaining the security deposit.", title: "Problematic clause", note: "Termination without notice conflicts with art. 27 of Law 392/1978." },
      ],
    },
    drafting: {
      docTitle: "PROFESSIONAL SERVICES AGREEMENT",
      intro: "Between {{a}}, Tax ID {{b}}…",
      art1Title: "Art. 1 - Subject",
      art1: "The professional undertakes to provide their intellectual services to the client for…",
      art2Title: "Art. 2 - Fee",
      art2: "The agreed fee is euros {{importo}}, plus VAT…",
      art3Title: "Art. 3 - Effective date",
      art3: "This agreement takes effect from {{data}}.",
      art4Title: "Art. 4 - Confidentiality",
      art4: "The parties undertake to keep confidential all information acquired during the performance of this agreement, including after its termination.",
      aiSuggestion: "AI Suggestion",
      ndaAdded: "✓ Confidentiality clause added.",
      ndaPrompt: "Missing confidentiality clause. Want to add it?",
      ndaCta: "Add clause",
      variables: "Variables",
    },
  },
  howItWorks: {
    eyebrow: "How it works",
    title: "Three steps. Results in seconds.",
    items: {
      ask: { title: "Ask a question", desc: "Write in natural language, as you would to a colleague at your firm." },
      analyze: { title: "LexAIPro analyzes", desc: "Searches 5M+ verified sources: legislation, case law, doctrine." },
      results: { title: "Get results", desc: "Structured answer with precise citations, ready for your work." },
    },
  },
  testimonials: { eyebrow: "Testimonials", title: "Chosen by professionals", aria: "Testimonial" },
  security: {
    eyebrow: "Security",
    title: "Uncompromising security. Always.",
    subtitle: "Built on privacy-by-design principles and European compliance.",
    badges: { gdpr: "GDPR Compliant", aiAct: "EU AI Act Compliant" },
    quote: "\"Security isn't an add-on: it's our foundation.\"",
    pillars: {
      training: { title: "Zero Training on Your Data", desc: "Your documents are never used to train our AI models. Absolute protection." },
      retention: { title: "Zero Retention Policy", desc: "Uploaded documents are deleted from the server after processing. We don't keep them." },
      crypto: { title: "End-to-End Encryption", desc: "Encryption in transit (TLS 1.3) and at rest (AES-256) for all data." },
      eu: { title: "EU/Italy Data Residency", desc: "Your data lives exclusively on European servers. Full GDPR compliance." },
    },
  },
  pricing: {
    eyebrow: "Pricing",
    title: "Transparent. Scalable. No surprises.",
    notice: "Payments coming soon · subscribe to get notified at launch",
    monthly: "Monthly",
    annual: "Annual",
    perMonth: "/month",
    onRequest: "On request",
    save: "Save €{{amount}}/year",
    mostChosen: "Most chosen",
    notify: "Notify me at launch",
    orFree: "or create a free account",
    footer: "Free beta open · First waitlist subscribers will get an early-bird discount at launch",
    plans: {
      starter: { name: "Starter", desc: "For the solo professional", features: ["1 user","100 AI queries/month","10 GB storage","AI search","Basic analysis","Email support"] },
      pro: { name: "Professional", desc: "For the all-rounder", features: ["1 user","Unlimited AI queries","50 GB storage","Advanced AI search","Advanced analysis","Drafting","Premium templates","Priority support"] },
      studio: { name: "Studio", desc: "For firms and corporate teams", features: ["From 5 users","Everything in Professional","Enterprise SSO","API Access","Team management","Account Manager","SLA guaranteed"] },
    },
  },
  faq: {
    eyebrow: "FAQ",
    title: "Frequently asked questions",
    items: [
      { q: "Can LexAIPro replace a lawyer?", a: "Absolutely not. LexAIPro is a professional tool designed to assist and amplify the lawyer's judgement, not to replace it. Final legal decisions always rest with the professional." },
      { q: "Are my documents safe?", a: "Yes. We apply a zero retention policy: documents are deleted from our servers after processing. Your data is never used to train AI models." },
      { q: "Does it only work for Italian law?", a: "The system is optimized for Italian law (codes, statutes, case law) with European law coverage. We are expanding to other EU jurisdictions." },
      { q: "Can I try it for free?", a: "Yes, we offer a 14-day free trial on all plans, no credit card required. You can cancel at any time." },
      { q: "Which documents can I analyze?", a: "All major formats: PDF, DOCX, DOC, TXT, RTF, HTML, ODT. Up to 50 MB per file and 10 files per upload." },
      { q: "Are citations reliable?", a: "LexAIPro always cites the regulatory or jurisprudential source. For rapidly-evolving areas we explicitly flag the need to verify recent updates." },
      { q: "Can I integrate it with my practice-management software?", a: "Yes. The Studio plan includes API access. Native integrations are available with Google Workspace, Microsoft 365, DocuSign and other tools." },
      { q: "What happens if I exceed the included queries?", a: "On the Starter plan we show a warning when you reach the limit and you can upgrade in one click. On Professional, queries are unlimited." },
    ],
  },
  finalCta: {
    titleA: "Start your free",
    titleHl: "14-day trial",
    subtitle: "No credit card required. Setup in under a minute.",
    primary: "Create your account",
    secondary: "Explore the demo",
  },
  footer: {
    tagline: "Artificial intelligence for legal professionals. No spam: only practical updates.",
    newsletter: "Newsletter", emailPlaceholder: "Your email", subscribe: "Subscribe", confirmed: "Subscription confirmed.", support: "Support",
    columns: { product: "Product", company: "Company", legal: "Legal" },
    links: { features: "Features", pricing: "Pricing", demo: "Demo", security: "Security", about: "About us", blog: "Blog", contact: "Contact", glossary: "Glossary", privacy: "Privacy Policy", terms: "Terms & Conditions", refunds: "Refund Policy", gdpr: "GDPR" },
    badges: { euData: "Data in EU", gdpr: "GDPR", aiAct: "AI Act" },
    login: "Login",
    whatsapp: "WhatsApp sales",
  },
  notFound: { title: "Page not found", desc: "The page you're looking for doesn't exist or has been moved.", cta: "Back to home" },
  language: { label: "Language", it: "Italiano", en: "English" },
  waitlist: {
    titleWaitlist: "Notify me at launch",
    titleNewsletter: "Subscribe to the newsletter",
    descWaitlist: "Payments are coming soon{{plan, select, undefined { } other { for the {{plan}} plan }}}. Leave your email: early subscribers get an early-bird discount.",
    descNewsletter: "Practical updates for lawyers, no spam. One-click unsubscribe.",
    emailLabel: "Email",
    emailPlaceholder: "you@lawfirm.com",
    subscribe: "Subscribe",
    sending: "Sending…",
    success: "Subscription confirmed. Check your inbox in a few minutes.",
    close: "Close",
    consent: "You agree to receive updates by email. You can unsubscribe at any time.",
    error: "Error",
  },
  paymentsWip: {
    title: "Payments coming soon",
    desc: "Payments are not active yet. Leave us your email and we'll reach out the moment everything is ready — early subscribers get an early-bird discount.",
    emailLabel: "Email",
    notify: "Notify me at launch",
    sending: "Sending…",
    success: "You're on the list. We'll email you the moment payments go live.",
    close: "Close",
    note: "No spam. You can unsubscribe at any time.",
    error: "Something went wrong. Please try again.",
  },
  app: {
    sidebar: {
      studio: "Workspace",
      mattersGroup: "Matters",
      productivity: "Productivity",
      communication: "Communication",
      account: "Account",
      admin: "Administration",
      homepage: "Home",
      dashboard: "Dashboard",
      research: "AI Search",
      documents: "Documents",
      analyses: "Analyses",
      history: "History",
      matters: "Matters",
      clients: "Clients",
      calendar: "Deadlines",
      team: "Team",
      drafting: "Drafting",
      generator: "Generate document",
      templates: "Templates",
      billing: "Subscription",
      settings: "Settings",
      wordAddin: "Word Add-in",
      docChat: "Document chat",
      inMatter: "inside matter",
      alerts: "Regulatory Alerts",
      soon: "soon",
      adminNav: "Admin",
      guide: "User guide",
      logout: "Sign out",
    },
    topbar: {
      queries: "queries",
      ofQueries: "{{used}} of {{limit}} queries",
    },
    billing: {
      title: "Subscription",
      description: "Plan, usage and payment history.",
      currentPlan: "Current plan",
      statusActive: "Active",
      statusPastDue: "Payment overdue",
      expiringOn: "Expires on {{date}}",
      resume: "Resume",
      cancelEow: "Cancel at period end",
      paymentMethod: "Payment method",
      aiQueriesUsed: "AI queries used",
      paymentsWipNotice: "Payments coming soon. Paid plans are not purchasable yet. Join the waitlist — early subscribers get an early-bird discount at launch.",
      changePlan: "Change plan",
      choosePlan: "Choose a plan",
      activePlan: "Active plan",
      free: "Free",
      choose: "Choose plan",
      notifyAtLaunch: "Notify me at launch",
      mostPopular: "Most popular",
      seats: "Seats:",
      perMonth: "/month",
      paymentsHistory: "Payment history",
      noPayments: "No payments yet.",
      colDate: "Date",
      colDescription: "Description",
      colAmount: "Amount",
      colStatus: "Status",
      invoice: "Invoice",
      cancelConfirm: "Cancel the subscription? You'll keep access until the end of the paid period.",
      cancelScheduled: "Cancellation scheduled for end of period.",
      restored: "Subscription restored.",
      planUpdated: "Plan updated. Pro-rated charge applied.",
      seatsUpdated: "Seats updated.",
      cannotUpdate: "Couldn't update the plan",
      cannotUpdateSeats: "Couldn't update seats",
      cannotCancel: "Couldn't cancel",
      cannotResume: "Couldn't resume",
      cannotOpenCheckout: "Couldn't open checkout",
      onWaitlist: "You're on the waitlist — we'll notify you when payments go live.",
      tryAgain: "Please try again shortly.",
      cycleMonthly: "Monthly",
      cycleAnnual: "Annual",
      annualSave: "−20%",
      aiQueriesPerMonth: "{{n}} AI queries/month",
      allModulesIncluded: "All modules included",
      modulesIncluded_one: "{{count}} Standard module included",
      modulesIncluded_other: "{{count}} Standard modules included",
      modulesSoldSeparately: "Modules sold separately",
      specializations: "Specializations",
      specializationsDesc: "Activate modules so the AI replies with dedicated system prompts, sources and glossary. Bundle discount: −15% from 3 modules, −25% from 5.",
      includedTag: "Included",
      summaryPlan: "{{name}} plan",
      summaryModules: "Modules ({{n}})",
      summaryIncludedDiscount: "Included in plan",
      summaryBundleDiscount: "Bundle discount ({{pct}}%)",
      summaryAnnualDiscount: "Annual discount ({{pct}}%)",
      summaryTotalMonthly: "Monthly total",
      summaryTotalMonthlyBilledAnnual: "Monthly total (billed yearly)",
      perYearAmount: "€{{amount}} per year",
      currentConfig: "Current configuration",
      confirmAndPay: "Confirm and pay",
      selectAtLeastOne: "Select at least one paid plan or module.",
    },
    upgrade: {
      eyebrow: "Upgrade plan",
      title: "More credits, more power",
      subtitle: "Pick the plan that fits your firm. Change or cancel any time.",
      creditsCurrent: "Credits on current plan · {{plan}}",
      aiRequests: "AI requests",
      exhausted: "Credits exhausted",
      exhaustedHint: "AI requests are temporarily paused. Upgrade your plan to resume.",
      recommended: "Recommended",
      perMonthQuota: "{{n}} AI requests / month",
      currentPlan: "Current plan",
      switchTo: "Switch to {{plan}}",
      included: "Already included",
      manageCurrent: "Manage current subscription",
      backToDashboard: "Back to dashboard",
      checkoutError: "Checkout error",
    },
  },
  pages: {
    status: {
      open: "Open",
      new: "New",
      in_analysis: "In analysis",
      in_progress: "In progress",
      awaiting_documents: "Awaiting documents",
      in_review: "In review",
      completed: "Completed",
      done: "Done",
      closed: "Closed",
      archived: "Archived",
      cancelled: "Cancelled",
      draft: "Draft",
    },
    risk: {
      low: "Low risk",
      medium: "Medium risk",
      high: "High risk",
      critical: "Critical",
    },
    priority: {
      low: "Low",
      medium: "Medium",
      high: "High",
      urgent: "Urgent",
    },
    verified: "Verified",
    editor: {
      undo: "Undo",
      redo: "Redo",
      h1: "Heading 1",
      h2: "Heading 2",
      h3: "Heading 3",
      blockquote: "Quote",
      bold: "Bold",
      italic: "Italic",
      underline: "Underline",
      strike: "Strikethrough",
      highlight: "Highlight",
      alignLeft: "Left",
      alignCenter: "Center",
      alignRight: "Right",
      alignJustify: "Justify",
      bulletList: "Bullet list",
      orderedList: "Numbered list",
      link: "Link",
      linkPrompt: "Link URL",
      table: "Table",
      hr: "Divider",
      aiContinue: "Continue with AI",
      aiGenerating: "Generating…",
    },
    common: {
      loading: "Loading…",
      error: "Error",
      saved: "Saved",
      deleted: "Deleted",
      delete: "Delete",
      open: "Open",
      close: "Close",
      cancel: "Cancel",
      confirm: "Confirm",
      retry: "Retry",
      back: "Back",
      search: "Search…",
      newSearch: "New search",
    },
    dashboard: {
      greeting: "Good day, {{name}}.",
      greetingDefault: "Good day, counsel.",
      description: "Overview of your firm: matters, recent analyses and upcoming deadlines.",
      allGood: "All in order",
      newMatter: "New matter",
      newAnalysis: "New analysis",
      overview: "Overview",
      openMatters: "Open matters",
      mattersTotal: "{{n}} total",
      deadlines7d: "Deadlines 7d",
      researchToday: "Searches today",
      documents: "Documents",
      aiQueries: "AI queries",
      currentPeriod: "Current period",
      recentMatters: "Recent matters",
      studio: "Workspace",
      seeAll: "See all →",
      noMatters: "No matters",
      createMatter: "Create matter",
      recentAnalyses: "Recent analyses",
      docs: "Documents",
      historyArrow: "History →",
      noAnalyses: "No analyses",
      analyzeDoc: "Analyze document",
      next7days: "Next 7 days",
      calendar: "Calendar",
      openArrow: "Open →",
      noDeadlines: "No deadlines",
      createEvent: "Create event",
      analysisDone: "Analysis completed",
      updated: "Updated {{date}}",
      qaLibrary: "Library",
      qaLibraryDesc: "Upload and index",
      qaAnalysis: "AI Analysis",
      qaAnalysisDesc: "Extract risks and clauses",
      qaGenerator: "Generator",
      qaGeneratorDesc: "Guided drafts",
      qaResearch: "Research",
      qaResearchDesc: "Statutes and case law",
    },
    documents: {
      title: "Documents",
      description: "Upload a document to get summaries, clause extraction and version comparison.",
      tabSummary: "Summary",
      tabClauses: "Clauses & risks",
      tabCompare: "Compare",
      beta: "Beta",
      summaryTitle: "Document summary",
      summaryDesc: "Upload a PDF, DOCX or scan and get a structured summary in seconds.",
      openAnalysis: "Open analysis",
      clausesTitle: "Clauses & risks",
      clausesDesc: "Review past analyses with extracted clauses and risk classification.",
      seeHistory: "See history",
      compareTitle: "Version comparison",
      compareDesc: "Smart diff between two contract drafts with substantive changes highlighted. Coming soon.",
      comingSoon: "Coming soon",
    },
    analyses: {
      title: "Analysis history",
      description: "Every document you've analyzed with AI.",
      newAnalysis: "New analysis",
      noneTitle: "No analyses yet",
      noneDesc: "Upload a PDF and analyze it to get started.",
      analyzeDocument: "Analyze a document",
      analysisOf: "Analysis from {{date}}",
      backToHistory: "History",
      delete: "Delete",
      deleteConfirm: "Delete this analysis?",
      deleted: "Analysis deleted",
      tabSummary: "Summary",
      tabParties: "Parties",
      tabDates: "Dates",
      tabClauses: "Clauses",
      tabRisks: "Risks",
      suggestedActions: "Suggested actions",
      sevHigh: "High",
      sevMedium: "Medium",
      sevLow: "Low",
      mitigation: "Mitigation",
      partiesCount: "{{n}} parties",
      clausesCount: "{{n}} clauses",
      risksCount: "{{n}} risks",
      risksHigh: "({{n}} high)",
    },
    history: {
      eyebrow: "History",
      title: "Your searches: {{n}} results",
      description: "History of searches, drafts and analyses.",
      newFolder: "New folder",
      newSearch: "New search",
      filterAll: "All",
      kindAsk: "Ask LexAI",
      kindDraft: "Draft Pleading",
      kindCompare: "Conforming & Diverging",
      allFolders: "All",
      noFolder: "No folder",
      noResults: "No searches found",
      startFirst: "Start your first search",
      colName: "Name",
      colDate: "Date",
      colKind: "Type",
      delete: "Delete",
      open: "Open",
      deleteConfirm: "Delete this search?",
      folderNamePrompt: "Folder name",
    },
    library: {
      title: "Private library",
      description: "Documents: {{n}} / {{quota}}. Searchable and organized.",
      searchPlaceholder: "Search by name or tag…",
      docsCount: "{{n}} documents",
      dropActive: "Drop to upload",
      dropIdle: "Drag files here or click to select",
      dropHint: "PDF, DOCX, images · max 50MB",
      emptyTitle: "Library is empty",
      emptyDesc: "Upload documents to get started.",
      indexed: "Indexed",
      notIndexed: "Not indexed",
      indexBtn: "Index for semantic search",
      uploadFailed: "Upload failed: {{name}}",
      uploaded: "Uploaded: {{name}}",
      indexedToast: "Indexed: {{name}} ({{n}} chunks)",
      indexFailed: "Indexing failed",
      invalidSession: "Invalid session",
      deleteConfirm: 'Delete "{{name}}"?',
    },
    research: {
      eyebrow: "Legal research",
      placeholder: "What do you want to know?",
      filterPlaceholder: "Filter searches",
      filterAll: "All",
      filterAsk: "Search",
      filterDraft: "Drafts",
      filterCompare: "Cases",
      folders: "Folders",
      newFolder: "New folder",
      folderCreated: "Folder created",
      folderDeleted: "Folder deleted",
      folderNamePrompt: "Folder name",
      folderRenamePrompt: "New name",
      folderDeleteConfirm: 'Delete the folder "{{name}}"? Searches will remain.',
      noSessions: "No sessions.",
      noFolder: "No folder",
      newSearch: "New search",
      compare: "Compare",
      credits: "Credits",
      undo: "Undo",
      revisionUndone: "Last revision undone",
      revisionLimit: "Revision limit reached",
      requestLimit: "Request limit reached.",
      streamError: "Stream error",
      requestError: "Error during the request",
      composerPlaceholder: "Type your question...",
      disclaimer: "Information generated by LexAIPro is produced via AI and does not constitute the opinion of a legal professional.",
      tabSources: "Sources",
      tabSentences: "Cases",
      tabRevisions: "Revisions",
      libraryHeader: "LexAI Library ({{n}})",
      sourcesZip: "ZIP sources",
      sourcesEmpty: "Retrieved statutory sources will appear here after a search.",
      pdfArticle: "Article PDF",
      aiBrief: "AI brief",
      briefGenerated: "Brief generated",
      sentenceFilters: { all: "All", conformi: "Conforming", difformi: "Diverging" },
      sentencesHint: "To search for conforming and diverging cases, start a new search in Conforming & Diverging mode from the home.",
      revisions: "Revisions",
      revisionPlaceholder: "Write what you want to change in the answer...",
      applyRevision: "Apply revision",
      noRevisionsLeft: "You've used all revisions for this session.",
      savePrompt: "Save prompt",
      savedPrompts: "Saved prompts ({{n}})",
      noSavedPrompts: "No saved prompts.",
      promptSaved: "Prompt saved",
      writePromptFirst: "Write a prompt first",
      query: "Question",
      copy: "Copy",
      listen: "Listen",
      report: "Report",
      copied: "Copied",
      reported: "Report sent",
      ttsUnavailable: "Speech synthesis unavailable",
      emptyTitle: "What do you want to know?",
      emptyDesc: "Answers grounded in Italian law, with verifiable citations article by article.",
      verifiedCitations: "Verified citations",
      officialSources: "Official sources",
      newSessionTitle: "New search",
      suggestions: [
        "Statute of limitations for tort liability",
        "Requirements for dismissal for just cause",
        "Difference between dolus eventualis and conscious negligence",
        "Unilateral withdrawal in a contract for works",
      ],
      downloadFailed: "Download failed",
      generateFailed: "Generation failed",
      exportFailed: "Export failed",
      preparingZip: "Preparing ZIP of {{n}} sources...",
      zipReady: "ZIP ready ({{kb}} KB)",
      rename: "Rename",
    },
    matters: {
      title: "Matters",
      description: "Manage all your matters in a Kanban view.",
      newMatter: "New matter",
      colOpen: "Open",
      colInProgress: "In progress",
      colClosed: "Closed",
      emptyTitle: "No matters",
      emptyDesc: "Create your first matter.",
      createMatter: "Create matter",
      noneInColumn: "No matters",
      openChat: "Open document chat",
      moveTo: "→ {{label}}",
      edit: "Edit",
      delete: "Delete",
      modalNew: "New matter",
      modalEdit: "Edit matter",
      save: "Save",
      create: "Create",
      fName: "Name",
      fNumber: "Number",
      fType: "Type",
      fTypePh: "Civil, criminal...",
      fValue: "Value (EUR)",
      fStatus: "Status",
      fDescription: "Description",
      nameRequired: "Matter name is required",
      created: "Matter created",
      updated: "Matter updated",
      deleted: "Matter deleted",
      deleteConfirm: 'Delete "{{name}}"?',
    },
    clients: {
      title: "Clients",
      description: "Client directory with Italian VAT and Fiscal Code validation.",
      newClient: "New client",
      emptyTitle: "No clients yet",
      emptyDesc: "Create your first client to get started.",
      createClient: "Create client",
      modalNew: "New client",
      modalEdit: "Edit client",
      save: "Save",
      fName: "Name / Company name",
      fEmail: "Email",
      fPhone: "Phone",
      fVat: "VAT",
      fFiscalCode: "Fiscal Code",
      fAddress: "Address",
      fNotes: "Notes",
      edit: "Edit",
      delete: "Delete",
      nameRequired: "Name required",
      vatInvalid: "Invalid VAT",
      fiscalCodeInvalid: "Invalid fiscal code",
      created: "Client created",
      updated: "Client updated",
      deleted: "Client deleted",
      deleteConfirm: 'Delete "{{name}}"?',
    },
    settings: {
      title: "Settings",
      description: "Professional profile and preferences.",
      profileSection: "Professional profile",
      passwordSection: "Change password",
      passwordHint: "At least 8 characters.",
      newPassword: "New password",
      confirmPassword: "Confirm",
      updatePassword: "Update password",
      updating: "Updating...",
      passwordTooShort: "Min 8 characters",
      passwordsMismatch: "Passwords do not match",
      passwordUpdated: "Password updated",
      fName: "First name",
      fLastName: "Last name",
      fFirm: "Firm",
      fBarOrder: "Bar Council",
      fBarOrderPh: "e.g. Milan",
      fBarNumber: "Bar number",
      fPhone: "Phone",
      fPec: "Certified email",
      saveChanges: "Save changes",
      saving: "Saving...",
      profileUpdated: "Profile updated",
      deleteSection: "Delete account",
      deleteDesc: "Permanently delete your account and all associated data. Active subscriptions will be canceled.",
      deleteCta: "Delete my account",
      deleting: "Deleting...",
      deleteConfirm: "Permanently delete the account? Active subscriptions will be canceled and data deleted. This action is irreversible.",
      accountDeleted: "Account deleted",
      deleteError: "Delete error",
    },
    calendar: {
      title: "Calendar",
      description: "Deadlines, hearings, appointments.",
      newEvent: "New event",
      emptyTitle: "No upcoming events",
      emptyDesc: "All future events will appear here.",
      createFirst: "Create your first event",
      modalNew: "New event",
      createEvent: "Create event",
      fTitle: "Title *",
      fStart: "Start *",
      fEnd: "End",
      fType: "Type",
      fPriority: "Priority",
      fLocation: "Location",
      fLocationPh: "Court of Milan, room 12…",
      fNotes: "Notes",
      titleRequired: "Title required",
      startRequired: "Start date required",
      created: "Event created",
      deleted: "Deleted",
      deleteConfirm: "Delete this event?",
      ariaDelete: "Delete",
      types: { hearing: "Hearing", deadline: "Deadline", appointment: "Appointment", reminder: "Reminder" },
      priorities: { low: "Low", medium: "Medium", high: "High", urgent: "Urgent" },
    },
    moduli: {
      title: "My modules",
      description: "Configure plan, billing cycle and specializations. See the live total before checkout.",
      goBilling: "Go to Billing",
      currentConfig: "Current configuration",
      summaryLine: "{{plan}} · {{cycle}} · {{n}} modules",
      cycleAnnual: "Annual",
      cycleMonthly: "Monthly",
      currentCost: "Current cost",
      perMonth: "/month",
      planAndCycle: "Plan and cycle (preview)",
      annualBadge: "−20%",
      allModulesIncluded: "All modules included",
      includedStandard: "{{n}} Standard modules included",
      modulesApart: "Modules billed separately",
      specializations: "Specializations",
      specializationsDesc: "Toggle modules on or off. The total on the left updates in real time.",
      planLabel: "{{name}} plan",
      modulesLabel: "Modules ({{n}})",
      includedDiscount: "Included in plan",
      bundleDiscount: "Bundle discount ({{pct}}%)",
      cycleDiscount: "Annual discount ({{pct}}%)",
      totalAnnualBilled: "Monthly total (billed annually)",
      totalMonthly: "Monthly total",
      perYear: "€{{amount}} per year",
      currentSel: "Current configuration",
      confirmPay: "Confirm and pay",
      noPaidItems: "No paid items to purchase.",
      confirmTitle: "Confirm the new configuration?",
      switchingTo: "You are about to switch to:",
      itemPlan: "{{plan}} plan ({{cycle}})",
      itemModules: "{{n}} modules ({{names}})",
      itemNone: "none",
      itemTotal: "Estimated total: €{{total}}/month",
      itemTotalAnnual: " · €{{annual}}/year",
      checkoutHint: "You'll be redirected to Paddle's secure checkout.",
      cancel: "Cancel",
      proceed: "Proceed to checkout",
    },
    agenti: {
      title: "Studio Agents",
      description: "10 AI agents specialized for an Italian law firm.",
      history: "History",
      dashboard: "Dashboard",
      claudeBadge: "CLAUDE",
      docBadge: "DOC",
      promptShort: "{{category}} · v{{v}}",
      backToAll: "All agents",
      promptVer: "{{short}} · prompt v{{v}}",
      docsLabel: "Context documents (PDF, DOCX, TXT — max 5)",
      extracting: "Extracting text…",
      dropFiles: "Drop or pick files",
      tooLarge: "{{name}}: too large (max 10MB)",
      extractError: "{{name}}: {{err}}",
      extractedChars: "{{name}}: {{n}} characters extracted",
      charSuffix: "({{n}} chars)",
      processing: "Processing…",
      runAgent: "Run agent",
      versionBadge: "v{{n}}",
      agentMeta: "Agent: {{id}} · prompt v{{v}}",
      engineLabel: "· Engine: {{engine}}",
      regenerate: "Regenerate with edits",
      whatToFix: "What needs fixing?",
      regenPlaceholder: "E.g. add a section on 231 risks, rephrase section 3 in a more cautious tone…",
      generating: "Generating…",
      genV: "Generate v{{n}}",
      cancel: "Cancel",
      versionsTitle: "Version history",
      versionLine: "v{{n}} · {{date}}",
      genericError: "Error",
      networkError: "Network error",
      versionGen: "v{{n}} generated · {{engine}}",
      upgradeTitle: "Studio Agents required",
      upgradeDesc: "This agent requires the Studio plan (Claude Sonnet 4.5 + GPT-5.2).",
      wallTitle: "Studio Agents",
      wallDesc: "10 specialized AI agents (KYC, M&A Due Diligence, Hearing Brief, GDPR Audit…) powered by GPT-5.2 and Claude Sonnet 4.5. Available only on the Studio plan.",
      upgradeStudio: "Upgrade to Studio",
      requiredMark: "*",
      dashOnly: "Dashboard available only on the Studio plan.",
      dashTitle: "Studio Dashboard",
      dashSubtitle: "Studio Agents usage · last 30 days",
      dashSessions: "Sessions",
      dashTokens: "Total tokens",
      dashCostEst: "Estimated cost",
      dashTopAgent: "Top agent",
      dashByAgent: "Sessions by agent",
      dashNoData: "No data yet.",
      dashRecent: "Recent sessions",
      dashColDate: "Date",
      dashColAgent: "Agent",
      dashColModel: "Model",
      dashColTokensOut: "Tokens out",
      dashColCost: "Cost",
      histOnly: "History available only on the Studio plan.",
      histTitle: "Studio Agents History",
      histSubtitle: "Search and filter sessions generated by agents.",
      histAgent: "Agent",
      histAll: "All",
      histFrom: "From",
      histTo: "To",
      histSearch: "Search title",
      histKeyword: "Keyword…",
      histNone: "No sessions found.",
    },
    templates: {
      title: "Templates",
      description: "Ready-made models, favorites, personal templates and generated document history.",
      tabCatalog: "Catalog ({{n}})",
      tabFavorites: "Favorites ({{n}})",
      tabMine: "Mine ({{n}})",
      tabHistory: "History",
      catalog: "Catalog",
      catalogTitle: "{{n}} templates for every need",
      catalogDesc: "Pleadings, contracts, opinions, demand letters and more. Fill in the missing fields and AI polishes for you.",
      searchPh: "Search by name, category or tag…",
      filterAll: "All",
      noFavorites: "No favorites yet. Tap the ⭐ on any catalog template.",
      noMine: "You don't have personal templates yet. Fill a catalog template and save it.",
      noMatch: "No templates match the search.",
      noHistory: "No documents generated yet.",
      personal: "Personal",
      open: "Open",
      preview: "Preview",
      use: "Fill in",
      close: "Close",
      advanced: "Advanced",
      basic: "Basic",
      complexityAdvanced: "Advanced",
      deleteTpl: "Delete template?",
      deleted: "Deleted",
      genericError: "Error",
      colDoc: "Document",
      colType: "Type",
      colUpdated: "Updated",
      colActions: "Actions",
      pdf: "PDF",
      docx: "DOCX",
      versions: "Versions",
      versionsTitle: "Version history",
      versionsDesc: "Restore a previous version of the document.",
      noVersions: "No saved versions.",
      version: "Version",
      restore: "Restore",
      restored: "Version restored",
    },
    generator: {
      title: "Generate document",
      description: "Guided form by type and tone. The draft opens in the editor.",
      stepType: "Type",
      stepData: "Data",
      stepTone: "Tone & context",
      back: "Back",
      continue: "Continue",
      backToType: "Type",
      missingFields: "Fill: {{fields}}",
      generated: "Document generated",
      toneCtxTitle: "Tone and context",
      toneCtxDesc: "Pick the register and optionally link a matter.",
      tone: "Tone",
      linkedMatter: "Linked matter (optional)",
      noneOption: "- None -",
      attachContext: "Attach context from matter documents",
      attachContextDesc: "I will use the most relevant excerpts from indexed documents as additional source (RAG).",
      generateDraft: "Generate draft",
    },
    analysis: {
      title: "Document analysis",
      description: "Upload a PDF: clauses, parties, deadlines and risks extracted by AI.",
      newBtn: "New",
      tooLarge: "File too large (max 20MB).",
      pdfErrorPrefix: "PDF error: {{msg}}",
      analysisError: "Error during analysis",
      ocrError: "OCR error",
      scannedToast: "Scanned PDF: use OCR to extract text.",
      drop: "Drop to analyze",
      uploadPdf: "Upload a PDF",
      uploadDesc: "Drag a PDF here or click to select. LexAIPro will extract key clauses, parties, deadlines, risks and suggestions.",
      uploadHint: "Max 20MB · Scanned PDFs supported (OCR)",
      pages: "{{n}} pages",
      pageN: "Page {{n}}",
      emptyPage: "Empty page",
      analyzing: "Analyzing…",
      waiting: "Waiting for analysis…",
      tabSummary: "Summary",
      tabParties: "Parties",
      tabDates: "Dates",
      tabClauses: "Clauses",
      tabRisks: "Risks",
      suggestedActions: "Suggested actions",
      sevHigh: "High",
      sevMedium: "Medium",
      sevLow: "Low",
      mitigation: "Mitigation",
    },
    admin: {
      title: "Admin",
      description: "Full management of users, roles and platform content.",
      fullAccess: "Full access",
      automations: "Automations",
      errors: "Errors",
      modulesPlans: "Modules & Plans",
      moduleSync: "Module sync",
      subscriptions: "Subscriptions",
      support: "Support",
      webhooks: "Webhooks",
      auditLog: "Audit log",
      adminBack: "← Admin",
      reload: "Reload",
      loading: "Loading…",
      noData: "No data",
      noEvents: "No events.",
      noUsers: "No users.",
      search: "Search…",
      actions: "Actions",
      details: "Details",
      retry: "Retry",
      retryScheduled: "Retry scheduled",
      retryFailed: "Retry failed",
      eventProcessed: "Event processed",
      genericError: "Error",
      loadError: "Loading error",
      stats: {
        users: "Users",
        admins: "Admins",
        matters: "Matters",
        analyses: "Analyses",
        drafts: "Drafts",
      },
      tabs: {
        usersRoles: "Users & Roles",
        matters: "Matters",
        analyses: "Analyses",
        drafts: "Drafts",
      },
      registeredUsers: "Registered users",
      cols: {
        user: "User",
        firm: "Firm",
        plan: "Plan",
        roles: "Roles",
        owner: "Owner",
        created: "Created",
        when: "When",
        type: "Type",
        env: "Env",
        status: "Status",
        attempts: "Attempts",
        error: "Error",
        next: "Next",
        lastError: "Last error",
        sequence: "Sequence",
        email: "Email",
        step: "Step",
        message: "Message",
        route: "Route",
        level: "Lvl.",
        source: "Source",
        aiQuota: "AI quota",
        limit: "Limit",
        lastPayment: "Last payment",
        modules: "Modules",
        cycle: "Cycle",
        totalPerMonth: "Total/month",
      },
      removeRoleHint: "Click to remove",
      addRole: "+ Role",
      planSet: "Plan set to {{plan}}",
      roleAssigned: "Role {{role}} assigned",
      roleRemoved: "Role {{role}} removed",
      deleteConfirm: "Delete permanently?",
      deleted: "Deleted",
      audit: {
        title: "Audit log",
        description: "All recorded administrative actions.",
        empty: "No actions recorded.",
        actor: "Actor",
        target: "Target",
        ip: "IP",
        details: "Details",
      },
      subs: {
        title: "User subscriptions",
        description: "Manage plan, limit and quota for all users.",
        planUpdated: "Plan updated",
        limitUpdated: "Limit updated",
        usageReset: "Usage reset",
        resetQuota: "Reset quota",
      },
      automationsPage: {
        title: "Email automations",
        description: "Status of drip sequences, automatic retries and dead-letter queue.",
        runNow: "Run now",
        runDone: "Done: {{n}} processed",
        active: "Active",
        completed: "Completed",
        failed24h: "Failed 24h",
        deadLetter: "Dead letter",
        all: "All",
        stopped: "Stopped",
        dlq: "Dead-letter",
        update: "Refresh",
        noRuns: "No runs.",
      },
      errorsPage: {
        title: "Errors & diagnostics",
        description: "Centralized tracking of app errors, quota events and crashes.",
        events24h: "Events 24h",
        events7d: "Events 7d",
        usersImpacted: "Users impacted 7d",
        quotaExhausted: "Quota exhausted 24h",
        trend14d: "Last 14 days trend",
        topMessages: "Top messages (7d)",
        noErrors: "No errors.",
        recent: "Recent events",
        allLevels: "All",
        allSources: "All sources",
        exportCsv: "CSV",
      },
      modulesPage: {
        title: "Admin · Modules & Plans",
        description: "Toggle modules, change plan and recompute prices for any user.",
        auditSync: "Audit sync",
        users: "Users",
        searchPh: "Search email/name…",
        edit: "Edit",
        editTitle: "Edit modules — {{email}}",
        plan: "Plan",
        cycle: "Cycle",
        cycleMonthly: "Monthly",
        cycleAnnual: "Annual (−20%)",
        activeModules: "Active modules",
        computedTotal: "Computed total",
        serverTotal: "Server total (verify)",
        bundleSummary: "{{n}} modules · bundle discount {{bundle}}% · annual discount {{cycle}}%",
        recomputeServer: "Recompute on server",
        save: "Save changes",
        saving: "Saving…",
        recomputed: "Recomputed total: €{{total}}/month",
        recomputeError: "Recompute error",
        saveError: "Save error",
        updated: "Updated",
      },
      moduleSyncPage: {
        title: "Audit · Module Subs Sync",
        description: "Recent webhook events, module sync errors, subscription state.",
        autoRefresh: "Auto-refresh",
        on: "ON",
        off: "OFF",
        updatedAt: "Updated: {{time}}",
        backModules: "← Modules",
        webhookEvents: "Webhook events",
        failedEvents: "Failed events",
        activeSubs: "Active subs",
        canceledSubs: "Canceled subs",
        recentWebhooks: "Recent webhook events",
        syncErrors: "Module sync errors (error_logs)",
        recentSubs: "Recent module subscriptions",
        noErrors: "No errors recorded.",
        noSubs: "No module subscriptions.",
        user: "User",
        module: "Module",
        expiry: "Expiry",
      },
      supportPage: {
        title: "Support — Tickets",
        description: "Manage tickets from all users.",
        totalTickets: "{{n}} total",
        ticketsTitle: "Tickets",
        all: "All",
        open: "Open",
        answered: "Answered",
        resolved: "Resolved",
        closed: "Closed",
        noTickets: "No tickets.",
        userPrefix: "user",
        replyPh: "Support reply…",
        send: "Send",
        replySent: "Reply sent",
        statusUpdated: "Status updated",
        backToList: "Back to list",
        statusOpen: "Open",
        statusAnswered: "Answered",
        statusResolved: "Resolved",
        statusClosed: "Closed",
        meSupport: "You (Support)",
        bot: "Assistant",
        userRole: "User",
        ticketHeader: "User {{user}} · Opened {{date}}",
      },
      webhooksPage: {
        title: "Paddle webhooks",
        description: "Audit log of received events, status, payload and manual retry.",
        totalEvents: "Total events",
        processed: "Processed",
        processing: "Processing",
        failed: "Failed",
        events: "Events",
        searchPh: "event_id, error, type…",
        allEnv: "All env",
        allStatus: "All statuses",
        retryManual: "Retry manually",
        eventProcessed: "Event processed",
        retryFailedReason: "Retry failed: {{reason}}",
        envBadge: "env: {{env}}",
        statusBadge: "status: {{status}}",
        attemptsBadge: "attempts: {{n}}",
      },
    },
    supporto: {
      title: "Support",
      description: "Get instant answers from the chatbot, browse FAQs, or open a ticket.",
      tabChatbot: "Chatbot",
      tabFaq: "FAQ",
      tabMyTickets: "My tickets",
      tabNew: "Open ticket",
      assistantTitle: "Support assistant",
      assistantHello: "Hi! I'm the LexAIPro support assistant. How can I help you?",
      thinking: "Thinking…",
      askPh: "Type your question…",
      sendError: "Error",
      assistantFallback: "Sorry, I can't reply right now. Try opening a ticket.",
      loading: "Loading…",
      noTickets: "No tickets yet. Open one from the \"Open ticket\" tab.",
      newReply: "New reply received",
      backToTickets: "Back to tickets",
      replyPh: "Type your reply…",
      sendReply: "Send reply",
      newTicket: "Open a new ticket",
      subject: "Subject",
      subjectPh: "Brief problem summary",
      category: "Category",
      priority: "Priority",
      description2: "Description",
      bodyPh: "Describe the problem or request in detail…",
      sendTicket: "Send ticket",
      ticketCreated: "Ticket opened. Support will reply as soon as possible.",
      paymentNotice: "For urgent payment issues contact",
      billingLink: "Billing",
      catBilling: "Billing",
      catTechnical: "Technical",
      catFeature: "Feature request",
      catAccount: "Account",
      catOther: "Other",
      prioLow: "Low",
      prioNormal: "Normal",
      prioHigh: "High",
      roleSupport: "Support",
      roleBot: "Assistant",
      roleYou: "You",
      faq: [
        { q: "How do I change plan?", a: "Go to **Account → Billing** and choose your plan. The change is immediate." },
        { q: "What are Studio Agents?", a: "10 specialized AI agents for recurring tasks (Due Diligence, KYC, GDPR, etc.). Exclusive to the Studio plan." },
        { q: "Which AI model do I use?", a: "Starter: Gemini Flash. Pro: GPT-5 mini. Studio: GPT-5.2 + Claude Sonnet 4.5." },
        { q: "Are my documents secure?", a: "Yes: encrypted at rest and in transit, isolated per user, GDPR compliant." },
        { q: "How do I export history?", a: "In **History**, select a conversation and use the export action (coming soon)." },
        { q: "How many AI queries do I have?", a: "Starter 100/month, Pro 1,000/month, Studio 10,000/month. See the counter on Dashboard." },
      ],
    },
  },
  mobile: {
    nav: {
      home: "Home",
      research: "Search",
      documents: "Documents",
      drafting: "Drafting",
      more: "More",
    },
    drawer: {
      title: "Everything",
      sections: {
        practice: "Practice",
        tools: "Tools",
        productivity: "Productivity",
        account: "Account",
        admin: "Admin",
      },
      logout: "Sign out",
      language: "Language",
    },
    actions: {
      back: "Back",
      close: "Close",
      menu: "Menu",
    },
  },
  common: {
    save: "Save",
    cancel: "Cancel",
    confirm: "Confirm",
    delete: "Delete",
    edit: "Edit",
    search: "Search",
    back: "Back",
    next: "Next",
    close: "Close",
    open: "Open",
    loading: "Loading…",
    retry: "Retry",
    error: "Error",
    success: "Done",
    yes: "Yes",
    no: "No",
    or: "or",
    more: "More",
    new: "New",
    add: "Add",
    send: "Send",
    create: "Create",
    update: "Update",
    sendingRequestTooLong: "The request took too long. Please try again.",
    networkError: "Network error",
    requestCancelled: "Request cancelled",
  },
  accountMenu: {
    label: "Account",
    admin: "Admin",
    logout: "Sign out",
  },
  upgradeWall: {
    title: "Studio plan exclusive feature",
    description: "Unlock Claude Sonnet 4.5, GPT-5.2, the 10 Studio Agents and the advanced dashboard.",
    feat1: "Claude Sonnet 4.5",
    feat2: "Unlimited GPT-5.2",
    feat3: "10 specialised Studio Agents",
    cta: "Upgrade to Studio",
    later: "Stay on my plan",
  },
  mobileHome: {
    title: "How can I help?",
    subtitle: "Pick a practice area and ask your question.",
    areaCivil: "Civil",
    areaLabor: "Labour",
    areaCorporate: "Corporate",
    areaPrivacy: "Privacy",
    areaBanking: "Banking & Insurance",
    areaFamily: "Family",
    areaTax: "Tax",
    areaIp: "Intellectual Property",
    areaAdmin: "Administrative",
    areaCriminal: "Criminal",
    areaConsumer: "Consumer",
    areaRealEstate: "Real Estate",
    areaCrisis: "Insolvency",
    areaCompliance: "Compliance",
    areaSchool: "Education law",
    moreAreas: "More areas…",
    chooseArea: "Pick an area",
    modeAsk: "Ask",
    modeDraft: "Draft",
    modeCompare: "Compare",
    inputPlaceholder: "Type your question…",
    attach: "Attach document",
    dictate: "Dictate",
    send: "Send",
    cancel: "Cancel",
    remove: "Remove",
  },
  drafting: {
    pageTitle: "Assisted drafting",
    pageDescription: "Court filings, contracts, opinions.",
    newDraft: "New draft",
    drafts: "Drafts",
    noDrafts: "No drafts yet.",
    titlePlaceholderFull: "Draft title",
    titlePlaceholder: "Title",
    save: "Save",
    more: "More",
    preview: "Preview",
    edit: "Edit",
    exportDocx: "Export DOCX",
    exportPdf: "Export PDF",
    docx: "DOCX",
    pdf: "PDF",
    revise: "Revise",
    revisePresets: {
      clarity: "Improve clarity",
      formal: "More formal tone",
      shorten: "Shorten",
      expand: "Expand argument",
      grammar: "Fix grammar",
    },
    customInstructionPrompt: "Custom instruction:",
    customInstruction: "Custom instruction…",
    startTitle: "Start drafting",
    startDesc: "Create a new draft or select an existing one.",
    emptyDoc: "Empty draft",
    nothingToContinue: "Write something before asking the AI to continue.",
    openEditorFirst: "Open the editor before revising.",
    selectOrWrite: "Select some text or write something first.",
    revised: "Text revised",
    aiError: "AI error",
    reviseError: "Revision error",
    pdfGenerated: "PDF generated",
    docxGenerated: "DOCX generated",
    exportFailed: "Export failed",
    exportPdfError: "PDF export error",
    exportDocxError: "DOCX export error",
      saving: "Saving…",
      saved: "Saved",
      savingError: "Error",
    },
  chat: {
    headerFallback: "Conversation",
    newChat: "New chat",
    notAvailable: "Conversation not available",
    notAvailableHint: "It may have been deleted or you don't have permission to view it.",
    backHome: "Back to home",
    noMessages: "No messages.",
    question: "Question",
    answer: "Answer",
    thinking: "Thinking",
    placeholder: "Continue the conversation…",
    send: "Ask",
    sending: "Sending…",
    attach: "Attach document",
    dictate: "Dictate",
    remove: "Remove {{name}}",
    filesPending: "{{n}} file(s) pending",
    fReady: "Ready",
    fUploading: "Uploading…",
    fError: "Error",
    mPages: "Pages",
    mAlerts: "Alerts",
    mConfidence: "Confidence",
    loadError: "Loading error",
    error: "Error",
    networkError: "Network error",
    verified: "Verified",
  },
  auth: {
    signupTitle: "Create your account",
    signupSubtitle: "Get started with LexAIPro for free",
    loginTitle: "Welcome back",
    loginSubtitle: "Sign in to your LexAIPro account",
    fullName: "Full name",
    email: "Email",
    password: "Password",
    create: "Create account",
    creating: "Creating...",
    signIn: "Sign in",
    signingIn: "Signing in...",
    or: "or",
    continueGoogle: "Continue with Google",
    signupGoogle: "Sign up with Google",
    continueApple: "Continue with Apple",
    signupApple: "Sign up with Apple",
    redirecting: "Redirecting...",
    haveAccount: "Already have an account?",
    noAccount: "Don't have an account?",
    register: "Sign up",
    accountCreated: "Account created!",
    signedIn: "Signed in",
    googleError: "Google sign-in error",
    appleError: "Apple sign-in error",
    googleSignupError: "Google sign-up error",
    appleSignupError: "Apple sign-up error",
    signupInProgress: "Signing up…",
    signinInProgress: "Signing in…",
    seoSignupTitle: "Start free - LexAIPro",
    seoSignupDesc: "Create your LexAIPro account: 14-day free trial, no credit card required.",
    seoLoginTitle: "Sign in - LexAIPro",
    seoLoginDesc: "Sign in to your LexAIPro account to use legal research, document analysis and AI drafting.",
  },
  onboarding: {
    steps: { profile: "Profile", firm: "Firm", areas: "Practice areas", ready: "Ready" },
    areas: {
      civil: "Civil", commercial: "Commercial", labor: "Labor", criminal: "Criminal",
      tax: "Tax", family: "Family", admin: "Administrative", immigration: "Immigration",
      ip: "Intellectual property", privacy: "Privacy & GDPR",
    },
    step0Title: "Let's start with the basics",
    step0Desc: "What's your name?",
    fName: "First name",
    fLastName: "Last name",
    step1Title: "Your firm",
    step1Desc: "Bar registration.",
    fFirm: "Firm name",
    fBarOrder: "Bar of",
    fBarOrderPh: "Milan",
    fBarNumber: "Registration number",
    step2Title: "Your practice areas",
    step2Desc: "Select at least one.",
    step3Title: "All set, {{name}}!",
    step3Default: "counsel",
    step3Desc: "Start exploring LexAIPro with 100 free AI queries.",
    welcome: "Welcome to LexAIPro!",
    back: "Back",
    next: "Next",
    enter: "Enter LexAIPro",
  },
  quotaDialog: {
    title: "AI credits exhausted",
    descUsage: "You have used <strong>{{used}}/{{limit}}</strong> AI queries on your plan.",
    descPlain: "You have used up the AI queries on your plan.",
    upgradeHint: "Upgrade your plan to keep using AI-assisted legal research.",
    close: "Close",
    upgrade: "Upgrade plan",
  },
  scannedPdf: {
    title: "Looks like a scanned PDF",
    desc: "We can't extract text: the {{n}} pages are images. Choose how to proceed.",
    ocrText: "OCR text",
    ocrTextLimit: "(max 20 pages)",
    ocrTables: "OCR + tables",
    pasteText: "Paste text",
    reupload: "Upload another file",
    pastePlaceholder: "Paste the document text here…",
    analyze: "Analyze text",
  },
  wordBanner: {
    close: "Close",
    title: "Use LexAI in Word",
    subtitle: "Your workflow, uninterrupted.",
    install: "Install the Add-in",
  },
  };

